$mol_view_tree2_to_js_test_ex_bidi_localized_default_value_foo $mol_object
	a? <=> b? @ \some1
